import React from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import GlassCard from '../../../customs/GlassCard';
import styles from './HeaderCard.module.css';
import { Typography } from '@mui/material';

const HeaderCard = (props) => {
  return (
    <StyledEngineProvider>
      <GlassCard className={styles.bg}>
        {props.icon}
        <Typography
          variant='h4'
          component='h4'
          sx={{
            fontFamily: `'Ubuntu', sans-serif`,
            letterSpacing: '5px',
          }}
          fontWeight='bold'
        >
          {props.title}
        </Typography>
      </GlassCard>
    </StyledEngineProvider>
  );
};

export default HeaderCard;
